__turbopack_context__.v({
  "isActiveTabLink": "tabLink-module-scss-module__SeLxHa__isActiveTabLink",
  "isDisabledTabLink": "tabLink-module-scss-module__SeLxHa__isDisabledTabLink",
  "tabLink": "tabLink-module-scss-module__SeLxHa__tabLink",
});
